export default __webpack_public_path__ + "static/media/kitchen_with_flowers.a1fc24cf.jpg";